import React from "react";
// Our modules
import { ProfileBadge } from "../../../components";

const Hero = ({ profile }) => {
  if (!profile) return null;

  const { name, userName, positions, thumbnail } = profile;
  // Find positions from the administrative organisation
  const newPositions = positions.filter(position => position.master === true);
  const position = newPositions ? newPositions[0] : "";

  return (
    <ProfileBadge
      username={userName}
      name={name.fullName}
      position={position}
      imageUrl={thumbnail}
      size={72}
    />
  );
};

export default Hero;
